import React, { PureComponent } from 'react';
import {setContextualHelp} from "actions/index.js";
import {setShowLFOs, setArrangementBottomMode, setShowPianoRoll} from "actions/index.js";
import {setSelectedLFO} from "actions/index.js";
import {LFO_TOGGLE_BUTTON} from 'constants/contextual-help.js';
import { connect } from "react-redux";

class LFOToggle extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    isToggled() {
        if (this.props.instrument !== undefined) {
            return this.props.instrument.isParameterConnectedToLFO(this.props.parameter, this.props.lfo);
        } else {
            return this.props.parameter && this.props.parameter.isConnectedToLFO(this.props.lfo);
        }
    }

    toggle() {
        if (this.props.instrument !== undefined) {
            this.props.instrument.toggleParameterWithLFO(this.props.parameter, this.props.lfo);
        } else {
            if (!this.props.parameter.isAudioParamEnabled()) {
                this.props.parameter.enableAudioParam();
            }
            if (!this.isToggled()) {
                if (this.props.connectToLFO) {
                    this.props.connectToLFO(this.props.lfo, true);
                } else {
                    this.props.parameter.connectToLFO(this.props.lfo, true);
                }
                // this.showMods(true);
                this.props.setSelectedLFO(this.props.lfo.number);
            } else {
                if (this.props.disconnectFromLFO) {
                    this.props.disconnectFromLFO(this.props.lfo, true);
                } else {
                    this.props.parameter.disconnectFromLFO(this.props.lfo, true);
                }
            }
        }
        this.setState({toggled: this.isToggled()});
    }

    showMods(show) {
        this.props.setShowLFOs(true);
    }

    onMouseOver(e) {
        e.stopPropagation();
        this.props.setContextualHelp(LFO_TOGGLE_BUTTON);
    }

    render() {
        let className = this.isToggled() ? ' toggled ' : '';
        let lfoNumber = this.props.lfos.indexOf(this.props.lfo);
        return (
            <div
              onMouseOver={(e) => this.onMouseOver(e)}
              onMouseLeave={() => this.props.setContextualHelp(undefined)}
              onClick={() => this.toggle()}
              className={"pushable parameter-lfo-toggle lfo-" + lfoNumber + className}>
              {lfoNumber + 1}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setSelectedLFO: (lfo) => dispatch(setSelectedLFO(lfo)),
        setShowLFOs: (show) => dispatch(setShowLFOs(show)),
        setArrangementBottomMode: (mode) => dispatch(setArrangementBottomMode(mode)),
        setShowPianoRoll: (show) => dispatch(setShowPianoRoll(show)),
    };
}
 
export default connect(null, mapDispatchToProps)(LFOToggle);
